import { render, staticRenderFns } from "./TextTestSubSection.vue?vue&type=template&id=17b1cbbc&scoped=true&"
import script from "./TextTestSubSection.vue?vue&type=script&lang=js&"
export * from "./TextTestSubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b1cbbc",
  null
  
)

export default component.exports